import React from "react";
import styles from "../../styles/ContentList.module.scss";
import { CONTENT_TYPE } from "../../store/constants";
import { hitHapticFeedback } from "@src/utils/index";
import ListItemThumbnail from "./ListItemThumbnail";
import ListItemDetails from "./ListItemDetails";
import { useRouter } from "@src/lib/router";
import isVideoExhausted from "../../helpers/isVideoExhausted";
import {
    showContentLockedBottomSheetAction,
    showCourseLockedBottomSheetAction,
    showTestIsLockedBottomSheetAction,
    showViewsExhaustedBottomSheetAction,
} from "@src/components/BottomSheets/store/actions";
import { useDispatch, useSelector } from "react-redux";
import handleOpenContent from "../../helpers/handleOpenContent";
import { funnelTrackAction } from "@src/components/Tabs/Overview/store/actions.js";
import {
    installmentsAlertStateEnum,
    trackIDMap,
} from "../../../Overview/store/constants";
import NotesButton from "./ContentDownloader/NotesButton";
import { getContentAttachmentsAction, setNotesModalContentAction, showNotesModalAction } from "../../store/actions";
import { t } from "i18next";
const ListItemAttachment = (
    {
        content,
        videoMarkedContentIds = new Set(),
        documentMarkedContentIds = new Set(),
        liveClassMarkedContentIds = new Set(),
    },
    ref
) => {
    // NEXTJS ROUTER
    const router = useRouter();

    // REDUX DISPATCH
    const dispatch = useDispatch();
    const isPurchased = useSelector((state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.isPurchased) || 0;
    const enableMarkContentAsDone = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.enableMarkContentAsDone) || false;

    // METHOD TO REDIRECT FOLDER ROUTE
    const changeFolderRoute = (folderId, contentCourseId, isGlobalCourse) => {
        let courseId = router.query.courseId;
        let urlParams = new URLSearchParams(window.location.search);
        let originalCourseId = urlParams?.get("originalCourseId");
        let route = `/${courseId}/folder/${folderId}`;
        if (originalCourseId) {
            route = `/${courseId}/folder/${folderId}?originalCourseId=${originalCourseId}`;
        }
        if (isGlobalCourse === 1) {
            route = `/${contentCourseId}/folder/${folderId}?originalCourseId=${courseId}`;
        }
        router.push(route);
    };

    // FETCHING STATES FROM REDUCER
    const isCourseLocked = useSelector(
        (state) =>
            state?.overviewReducer?.overViewDetails?.course?.installments
                ?.installmentAlertState
    );
    const state = useSelector(
        (state) => state?.overviewReducer?.overViewDetails?.course
    );
    // HANDLING CLICK ON ITEM
    const handleItemClicked = (content) => {
        localStorage.setItem("currentItem", JSON.stringify(content));
        // console.log(router.query);
        hitHapticFeedback();
        dispatch(
            funnelTrackAction({
                type: trackIDMap.contentView,
                isPurchased:
                    state?.installments?.paidInstallmentSummary?.isPaymentComplete ===
                    1 || state?.metaData?.isPurchased === 1,
                courseId: router?.query?.courseId,
                folderId: router?.query?.folderId || 0,
                contentId: content.id,
                contentType: content.contentType,
            })
        );
        if (
            isCourseLocked === installmentsAlertStateEnum.COURSE_LOCKED &&
            content?.isLocked
        ) {
            dispatch(showCourseLockedBottomSheetAction(true));
            return;
        }
        const { id, contentType, contentCourseId, isGlobalCourse } = content;
        switch (contentType) {
            case CONTENT_TYPE.FOLDER: {
                changeFolderRoute(id, contentCourseId, isGlobalCourse);
                break;
            }
            case CONTENT_TYPE.LIVE_CLASS:
            case CONTENT_TYPE.VIDEO: {
                // SHOWING CONTENT IS LOCKED BOTTOM SHEET IF LOCKED
                // if (content?.isLocked)
                if (
                    content.isScheduled ||
                    (!content.isPurchased && content?.isLocked)
                ) {
                    dispatch(showContentLockedBottomSheetAction(true));
                }
                // IF VIDEO LIMIT IS EXHAUSTED OPENING EXHAUSTED BOTTOMSHEET
                else if (isVideoExhausted(content)) {
                    dispatch(showViewsExhaustedBottomSheetAction(true));
                } else {
                    handleViewContentItem(content);
                }
                break;
            }
            case CONTENT_TYPE.DOCUMENT: {
                // SHOWING CONTENT IS LOCKED BOTTOM SHEET IF LOCKED
                // if (content?.isLocked)
                if (
                    content.isScheduled ||
                    (!content.isPurchased && content?.isLocked)
                ) {
                    dispatch(showContentLockedBottomSheetAction(true));
                } else handleViewContentItem(content);
                break;
            }
            case CONTENT_TYPE.TEST: {
                if (
                    content.isScheduled ||
                    (content?.isPurchased && content?.isLocked) ||
                    (!content.isPurchased && content?.isLocked)
                ) {
                    dispatch(showTestIsLockedBottomSheetAction(true));
                }
                // OPENING THE TEST STATS PAGE IF ALREADY ATTEMPTED
                else if (
                    content?.typeOfTest === 2 &&
                    content?.numberOfAttemptsRemaining === 0
                ) {
                    handleViewContentItem(content);
                } else if (
                    content?.scoredMarks ||
                    content?.scoredMarks === 0 ||
                    (content?.numberOfAttemptsRemaining === 0 &&
                        content?.totalAttempts !== -1)
                ) {
                    router.push(
                        `/${router?.query?.courseId}/teststats/${content?.testId}/${content?.id}`
                    );
                }
                // ELSE ATTEMPTING TEST
                else {
                    handleViewContentItem(content);
                }
                break;
            }
        }
    };

    // FUNCTION TO VIEW CONTENT ITEM
    const handleViewContentItem = (content) => {
        handleOpenContent({
            ...content,
            courseId: +router?.query?.courseId,
            originalCourseId: parseInt(router?.query?.originalCourseId),
        });
    };

    const handleNotesClick = (content) => {
        dispatch(setNotesModalContentAction(content));
        dispatch(showNotesModalAction(true)); // Open the modal
        if (!content?.attachments?.length && content?.hasAttachments) {
            dispatch(
                getContentAttachmentsAction({ sourceContentId: content?.id })
            );
        }
    };

    const contetTypeValue = {
        2: videoMarkedContentIds,
        3: documentMarkedContentIds,
        5: liveClassMarkedContentIds,
    };
    const isBookMarkIconVisible =
        (content?.contentType === CONTENT_TYPE.VIDEO ||
            content?.contentType === CONTENT_TYPE.LIVE_CLASS) &&
        (isPurchased === 1 || content?.isPurchased === 1) &&
        !content?.isScheduled && enableMarkContentAsDone;
    const isContentMarkedDone = contetTypeValue[content?.contentType]?.has(content?.id) || false;

    return (
        <div className={styles.contentList__item}>
            <div
                className={styles.contentList__item__thumbnailCol}
                ref={ref}
                onClick={() => handleItemClicked(content)}
            >
                <ListItemThumbnail content={content} />
                {isContentMarkedDone && isBookMarkIconVisible ? (
                    <span className={styles.contentList__item__completed}>
                        <span className={styles.contentList__item__completed__icon} aria-hidden="true">
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="6" cy="6" r="6" fill="currentColor" />
                                <path
                                    d="M3.4 6.15L5.15 7.9L8.6 4.2"
                                    stroke="#fff"
                                    strokeWidth="1.3"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        {t(
                            "components.tabs.content.components.contentList.listItem.completedText",
                            "Completed"
                        )}
                    </span>
                ) : null}
            </div>

            <div className={styles.contentList__item__content} onClick={() => handleNotesClick(content)}>
                <ListItemDetails
                    content={content}
                    className={styles.contentList__item__content__text}
                />
                <div
                    className={styles.contentList__item__content__button}
                >
                    <NotesButton onClick={() => handleNotesClick(content)}/>
                </div>
            </div>
        </div>
    );
};

const ListItemForAttachments = React.forwardRef(ListItemAttachment);

export default ListItemForAttachments;